import type { Stock } from 'product/types/Stock'

const FULFILLED = 'fulfilled'

export function multipleUrlsFetcher(
	urls: string[],
	options: RequestInit = {}
): Promise<Record<string, Stock>> {
	const fetchData = (url: string) =>
		fetch(url, { ...options, next: { revalidate: 0 } })
			.then((response) =>
				response.ok
					? response.json()
					: Promise.reject(`Error fetching ${url} data`)
			)
			.then((data) => ({ [url]: data }))
			.catch((_error) => {})

	return Promise.allSettled(urls.map((url) => fetchData(url))).then(
		(dataArray) => {
			return dataArray.reduce((acc, current) => {
				if (current.status === FULFILLED) {
					return {
						...acc,
						...current.value,
					}
				}
				return acc
			}, {})
		}
	)
}
